import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 6H21V4.5H3V6Z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 12.75H21V11.25H3V12.75Z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 19.5H21V18H3V19.5Z" })), 'Menu');
